module.exports = __webpack_public_path__ + "img/farmer-in-field.5f6c8ece.jpg";